import React, { useCallback, useEffect, useState } from "react";
import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import Button from "../components/form/Button";
import { Document, pdf, PDFDownloadLink } from "@react-pdf/renderer";
import CompanySNReport from "./pdf/CompanySNReport";
import { useSelector } from "react-redux";
import { API_URL } from "../config/host";
import NoDataFound from "../components/NoDataFound";
import TableSkeleton from "../components/loader/TableSkeleton";
import DropdownCheckbox from "../components/form/DropdownCheckbox";
import { useLocation } from "react-router-dom";
import CompanyContextSummeryReport from "./pdf/CompanyContextSummeryReport";

const CompanyContextualSummary = () => {
  const { i18n, t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState();
  const user = useSelector((state) => state.auth?.user);
  //const [positions, setPositions] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const detailsId = searchParams.get("detailsId");
  const [predictorWeight, setPredictorWeight] = useState(0);
  const [experienceWeight, setExperienceWeight] = useState(0);
  const [concernsWeight, setConcernWeight] = useState(0);
  const [performanceWeight, setPerformanceWeight] = useState(0);
  const [educationWeight, setEducationWeight] = useState(0);
  const [yearWithCompanyWeight, setYearWithCompany] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);

  //   Summary List Api Call
  useEffect(() => {
    const loaWeights = async () => {
      try {
        const result = await postData("scorecard/list", {
          status: 1,
        });
        if (result.data) {
          let total = 0;
          result.data.map((value, key) => {
            if (value.alias === "potential_predictor_score") {
              setPredictorWeight(
                value?.company_weight ? value?.company_weight : value?.weight
              );
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            }
            if (value.alias === "executive_experience") {
              setExperienceWeight(
                value?.company_weight ? value?.company_weight : value?.weight
              );
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            }
            if (value.alias === "concerns") {
              setConcernWeight(
                value?.company_weight ? value?.company_weight : value?.weight
              );
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            }
            if (value.alias === "recent_performance_review") {
              setPerformanceWeight(
                value?.company_weight ? value?.company_weight : value?.weight
              );
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            }
            if (value.alias === "highest_level_education") {
              setEducationWeight(
                value?.company_weight ? value?.company_weight : value?.weight
              );
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            }
            if (value.alias === "years_with_company") {
              setYearWithCompany(
                value?.company_weight ? value?.company_weight : value?.weight
              );
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            }
            setTotalWeight(total);
            return value;
          });
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loaWeights();
  }, []);

  const loadList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await postData("/contextual-information/list", {
        sortQuery: { created_at: 1 },
        created_by: detailsId ? [detailsId] : null,
      });

      if (result.data) {
        const formattedList = result.data.map((value) => {
          // Safe numeric extraction
          const predictorCalculation =
            (predictorWeight * (value?.predictor_score || 0)) / 100;
          const experienceCalculation =
            (experienceWeight * (value?.experience?.point || 0)) / 100;
          const concernsCalculation =
            (concernsWeight * (value?.concern_score || 0)) / 100;
          const performanceCalculation =
            (performanceWeight * (value?.performances?.point || 0)) / 100;
          const educationCalculation =
            (educationWeight * (value?.educations?.point || 0)) / 100;
          const yearWithCompanyCalculation =
            (yearWithCompanyWeight * (value?.yearWithCompany?.point || 0)) / 100;

          // Handle arrays safely (grab first element’s isPass, or decide logic)
          const desireResult =
            value?.desires?.length > 0
              ? value.desires[0]?.isPass
                ? 1
                : 2
              : null;

          const loyaltyResult =
            value?.loyalties?.length > 0
              ? value.loyalties[0]?.isPass
                ? 1
                : 2
              : null;

          const retirementResult =
            value?.retirements?.length > 0
              ? value.retirements[0]?.isPass
                ? 1
                : 2
              : null;

          // Final score calculation
          let overallWeightScore = 0;
          if (desireResult !== 2 && loyaltyResult !== 2 && retirementResult !== 2) {
            overallWeightScore =
              predictorCalculation +
              experienceCalculation +
              concernsCalculation +
              performanceCalculation +
              educationCalculation +
              yearWithCompanyCalculation;
          }

          return {
            ...value,
            overallWeightScore: Number(overallWeightScore.toFixed(2)), // always a number
          };
        });

        setList(formattedList);
      }
    } catch (err) {
      console.error("Error loading list:", err.message);
    } finally {
      setLoading(false);
    }
  }, [
    detailsId,
    predictorWeight,
    experienceWeight,
    concernsWeight,
    performanceWeight,
    educationWeight,
    yearWithCompanyWeight,
  ]);

useEffect(() => {
  loadList();
}, [loadList]);

  const getDownload = (e) => {
    e.preventDefault();
    if (e.target.tagName.toLowerCase() === "a") {
      window.open(e.target.href, "_blank");
    }
  };

  // const positionSelect = async (id, checked) => {
  //   if (id && id === "all") {
  //     setPositions(
  //       positions.map((pos) => {
  //         if (checked) {
  //           return { ...pos, isEnabled: checked };
  //         } else {
  //           return { ...pos, isEnabled: false };
  //         }
  //       })
  //     );
  //   } else {
  //     setPositions(
  //       positions.map((pos) => {
  //         if (pos._id === id) {
  //           return { ...pos, isEnabled: checked };
  //         } else {
  //           return pos;
  //         }
  //       })
  //     );
  //   }
  // };

  // useEffect(() => {
  //   async function positionData() {
  //     try {
  //       const result = await postData("position/list", {
  //         sortQuery: { ordering: 1 },
  //         type: 1,
  //         status: 1,
  //         isStep: 1,
  //       });
  //       if (result.data) {
  //         setPositions(
  //           result.data.map((value, key) => {
  //             return {
  //               _id: value?._id,
  //               label: value?.name + " (" + value?.short_name + ")",
  //               isEnabled: true,
  //             };
  //           })
  //         );
  //         //setPositions(result.data);
  //       } else {
  //         console.log("position list message", result.message);
  //       }
  //     } catch (error) {
  //       console.log("Error position list catch", error.message);
  //     }
  //   }
  //   positionData();
  // }, []);

  // useEffect(() => {
  //   let SelectedPosition = [];

  //   if (positions) {
  //     positions.map((usr) => {
  //       if (usr.isEnabled) {
  //         SelectedPosition.push(usr._id);
  //       }
  //     });
  //   }
  //   if (SelectedPosition.length > 0) {
  //     loadList(SelectedPosition);
  //   }
  // }, [positions]);

  const handleSingleDownloadClick = async (e) => {
    e.preventDefault();
    // Open a blank tab immediately to avoid pop-up blockers.
    const newTab = window.open("", "_blank");
    // Display a styled loading message with Tailwind CSS.
    newTab.document.write(`
      <html lang="en">
        <head>
          <script src="https://cdn.tailwindcss.com"></script>
          <style>
            body {
              @apply bg-gray-100;
              margin: 0;
              height: 100vh;
            }
            .loader-container {
              @apply flex flex-col justify-center items-center h-screen;
            }
            .loader {
              width: 50px;
              aspect-ratio: 1;
              display: grid;
              border-radius: 50%;
              background:
                linear-gradient(0deg, rgb(0 0 0 / 50%) 30%, #0000 0 70%, rgb(0 0 0 / 100%) 0) 50% / 8% 100%,
                linear-gradient(90deg, rgb(0 0 0 / 25%) 30%, #0000 0 70%, rgb(0 0 0 / 75%) 0) 50% / 100% 8%;
              background-repeat: no-repeat;
              animation: l23 1s infinite steps(12);
            }
            .loader::before,
            .loader::after {
              content: "";
              grid-area: 1 / 1;
              border-radius: 50%;
              background: inherit;
              opacity: 0.915;
              transform: rotate(30deg);
            }
            .loader::after {
              opacity: 0.83;
              transform: rotate(60deg);
            }
            @keyframes l23 {
              100% {
                transform: rotate(1turn);
              }
            }
          </style>
        </head>
        <body>
         <div class="flex justify-center items-center mt-20 loader-container">
          <div class="flex flex-col items-center justify-center space-y-4">
            <div class="loader"></div>
            <p class="text-teal-700 text-lg font-semibold mt-4">Generating your PDF... Please wait.</p>
          </div>
         </div>
        </body>
      </html>
      `);

    try {
      // Generate the PDF blob asynchronously.
      const blob = await pdf(
        <Document>
          <CompanyContextSummeryReport
            user={user}
            companyLogo={API_URL + user?.image}
            list={list || []}
          />
        </Document>
      ).toBlob();

      // Create a URL from the blob.
      const blobURL = URL.createObjectURL(blob);
      // Redirect the new tab to the blob URL (load the PDF).
      newTab.location.href = blobURL;
    } catch (error) {
      // Display an error message in the new tab.
      newTab.document.body.innerHTML = `
        <div class="flex flex-col items-center justify-center h-screen bg-red-100">
          <p class="text-red-700 text-lg font-semibold">Failed to load PDF. Please try again later.</p>
          <p class="text-sm text-gray-600">${error.message}</p>
        </div>
      `;
      console.error("PDF generation error:", error);
    }
  };  

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-4">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-y-4">
            <div className="text-3xl font-bold text-gray-800">
            {t("company_repeat_candidate_overview")}
            </div>
            <div className="flex items-center gap-2"
            data-tooltip-id={`buttonReport${19644}`}
            data-tooltip-place="bottom"
            >
            {/* <Button
                buttonType={"button"}
                isCustomLabel={true}
                customData={
                <>
                    <i className={"fa-fw fa-solid fa-file-pdf"}></i>
                    <div className={"text-sm font-semibold whitespace-nowrap"}>
                    <PDFDownloadLink
                        document={
                        <Document>
                          <CompanyContextSummeryReport
                            user={user}
                            companyLogo={API_URL + user?.image}
                            list={list || []}
                          />
                        </Document>
                        }
                        fileName="company_succession_summary_report.pdf"
                    >
                        {({ loading }) =>
                        loading ? t("Loading Report...") : t("Download Report")
                        }
                    </PDFDownloadLink>
                    </div>
                </>
                }
                buttonClasses={"flex justify-center items-center gap-2 bg-teal-500  text-white rounded text-base sm:text-lg h-8 sm:h-10 py-0 px-2 sm:px-3 transition-all duration-200 cursor-pointer !w-full"}
                buttonHasLink={false}
                functions={(e) => getDownload(e)}
            /> */}
            <button
              type="button"
              className="flex justify-center items-center gap-2 bg-teal-500  text-white rounded text-base sm:text-lg h-8 sm:h-10 py-0 px-2 sm:px-3 transition-all duration-200 cursor-pointer !w-full"
              onClick={handleSingleDownloadClick}
            >
              <i className="fa-fw fa-regular fa-download"></i>
              <div className="text-xs font-semibold whitespace-nowrap">
                {t("download_report")}
              </div>
            </button>
            <Tooltip
                id={`buttonReport${19644}`}
                className="!text-xs !bg-teal-700 text-white z-50 rounded !py-2 px-3"
                render={() => (
                <div className="font-medium text-sm">
                    Click to Download Company Succession Summary Report
                </div>
                )}
            />
            </div>
        </div>

        {/* Filter Section */}
        {/* <div className="relative flex justify-start items-center mb-4 space-x-2">
            <div className="relative z-20">
            <DropdownCheckbox data={positions} functions={positionSelect} />
            </div>
        </div> */}

        {/* Table Section */}        
        <div className="overflow-x-auto rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-black">
              <tr>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Candidate Name
                </th>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Position
                </th>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Planner
                </th>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Plan Position
                </th>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Candidate Overall Weighted Score
                </th>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Recent Performance Review
                </th>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Conditions of Concern Score
                </th>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Potential Predictors Score
                </th>
                <th scope="col" className="px-3 py-3 text-xs font-semibold text-white capitalize text-center">
                  Candidate Retirement Window
                </th>
              </tr>
            </thead>            
            
            <tbody className="bg-white divide-y divide-gray-200">
              {!loading && list?.length > 0 ? (
                (() => {
                  const groupedData = [];
                  const nameGroups = {};
                  list.forEach(item => {
                    if (!nameGroups[item.name]) {
                      nameGroups[item.name] = [];
                    }
                    nameGroups[item.name].push(item);
                  });

                  Object.keys(nameGroups).forEach((name, groupIndex) => {
                    nameGroups[name].forEach((item, itemIndex) => {
                      groupedData.push({
                        ...item,
                        isFirstInGroup: itemIndex === 0,
                        isLastInGroup: itemIndex === nameGroups[name].length - 1,
                        groupSize: nameGroups[name].length,
                        groupIndex: groupIndex
                      });
                    });
                  });
                  
                  const getPerformanceReviewBg = (name, currentItem) => {
                    const sameNameItems = list.filter(item => item?.name === name); 
                    if (sameNameItems.length < 2) {
                      return "bg-sky-300"; 
                    }                    
                    const currentPerformanceReviewId = currentItem?.performance_review?._id || null;  
                    if (currentPerformanceReviewId === null) {
                      return "bg-sky-300";
                    }                    
                    
                    const countOfCurrentId = sameNameItems.filter(item => 
                      (item?.performance_review?._id || null) === currentPerformanceReviewId
                    ).length;                    
                    
                    return countOfCurrentId >= 2 ? "bg-green-300" : "bg-sky-300";
                  };
                   
                  const getRetirementWindowsBg = (name, currentItem) => {
                    const sameNameItems = list.filter(item => item?.name === name);                    
                    if (sameNameItems.length < 2) {
                      return "bg-sky-300"; 
                    }
                    
                    const currentRetirementWindowId = currentItem?.retirement_windows?._id || null;
                    if (currentRetirementWindowId === null) {
                      return "bg-sky-300";
                    }                    
                    
                    const countOfCurrentId = sameNameItems.filter(item =>
                      (item?.retirement_windows?._id || null) === currentRetirementWindowId
                    ).length;                    
                   
                    return countOfCurrentId >= 2 ? "bg-green-300" : "bg-sky-300";
                  };

                  return groupedData.map((item, index) => (
                    <React.Fragment key={`row-${index}`}>
                      {item.isFirstInGroup && item.groupIndex > 0 && (
                        <tr className="bg-gray-50">
                          <td colSpan={9} className="px-6 py-2">
                            <div className="border-t border-gray-300"></div>
                          </td>
                        </tr>
                      )}
                      
                      <tr className={`hover:bg-gray-50 transition-colors duration-150 ${
                        item.isFirstInGroup ? 'border-t-2 border-t-blue-200' : ''
                      }`}>
                        <td className={`px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left ${
                          item.isFirstInGroup ? 'font-bold' : 'font-normal'
                        }`}>
                          {item?.name || "-"}
                          {item.isFirstInGroup && item.groupSize > 1 && (
                            <div className="text-xs text-blue-600 mt-1">
                              ({item.groupSize} entries)
                            </div>
                          )}
                        </td>                       
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                          {item?.position || "-"}
                        </td>                        
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                          {item?.planner || "-"}
                        </td>                        
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                          {item?.planner_position || "-"}
                        </td>                        
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-black text-center bg-sky-300">
                          {item?.overallWeightScore || ""}
                        </td>                       
                        <td className={`px-6 py-4 whitespace-nowrap text-sm text-black text-center ${
                          getPerformanceReviewBg(item.name, item)
                        }`}>
                          {item?.performance_review?.name || "-"}
                          {item?.performance_review?.name && (
                            <span className="block text-xs">
                              ({item?.performance_review?.number})
                            </span>
                          )}
                        </td>                        
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-black text-center bg-sky-300">
                          {item?.concern_score !== undefined ? item.concern_score : "-"}
                        </td>                        
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-black text-center bg-sky-300">
                          {item?.predictor_score !== undefined ? item.predictor_score : "-"}
                        </td>                        
                        <td className={`px-6 py-4 whitespace-nowrap text-sm text-black text-center ${
                          getRetirementWindowsBg(item.name, item)
                        }`}>
                          {item?.retirement_windows?.name || "-"}
                        </td>
                      </tr>
                    </React.Fragment>
                  ));
                })()
              ) : (
                <tr>
                  <td colSpan={9} className="px-6 py-4 text-center text-sm text-gray-500">
                    {loading ? <TableSkeleton /> : <NoDataFound label={t("no_data_found")} />}
                  </td>
                </tr>
              )}
            </tbody>
            
          </table>
        </div>

    </div>
  );
};

export default CompanyContextualSummary;
